// game-objects
import { ArBitmapText, ArContainer, ArSprite, Counter, gsap, soundService } from "@aceroll/core";

export class MultiplierPanel extends ArContainer {
	multipliers = [];
	counters = [];

	constructor() {
		super('multiplier-panel');

		for (let index = 0; index < 5; index++) {
			this.#createLabel(index);
		}

		this.visible = true;
		window.mp = this;
	}

	async show() {
		this.visible = true;
		await this.#showLabel();
	}

	async hide() {
		await this.#hideLabel();
		this.resetMultiplier();
		this.visible = false;
	}

	#createLabel(index) {
		const positionX = 194 * index;
		const panel = this.addChild(ArSprite.from('common-multiplier_panel', 'Multiplier Panel'));
		panel.anchor.set(0.5);
		panel.position.set(positionX, 0);

		//from(alias, text, label, style = { align: 'center' })
		const value = ArBitmapText.from('bitmap-hearts', 'test', 'multiplier-panel-label');
		// const value = ArText.from('1', 'splashFeatureTitle', 'multiplier-panel-label');
		value.anchor.set(0.5);
		value.style.fontSize = 92;
		value.style.letterSpacing = -40;
		value.position.set(positionX - 22, -9);
		value.text = 'x1';
		this.multipliers.push(value);

		const counter = new Counter({
			duration: 1000,
			callback: (v) => {
				if (v < 1) { return; }
				const newValue = 'x' + ~~v;
				if (newValue === value) { return; }
				value.text = newValue;
				// Reduce the font size. Assume max length is x999.
				value.style.fontSize = 100 - newValue.length * 4;
			}
		});
		this.counters.push(counter);

		this.addChild(panel);
		this.addChild(value);
		this.setValue(index, 1);
	}

	setValue(index, value) {
		const counter = this.counters[index];
		counter.playTo(value, 300);
	}

	async #showLabel(duration = 1) {
		return new Promise(resolve => {
			this.visible = true;
			gsap.fromTo(this,
				{ alpha: 0 },
				{ alpha: 1, duration, onComplete: () => resolve() }
			);
		});
	}

	async #hideLabel(duration = 0.5) {
		return new Promise(resolve => {
			gsap.fromTo(this,
				{ alpha: 1 },
				{
					alpha: 0, duration, onComplete: () => {
						this.visible = false;
						resolve();
					}
				}
			);
		});
	}

	reset() {
		// this.visible = false;
		for (let i = 0; i < this.multipliers.length; i++) {
			this.setValue(i, 1);
		}
	}
}
